import ApiGet from "../../../../../api-controller-mod/api-serv/get-api/getApi";
import ApiPatch from "../../../../../api-controller-mod/api-serv/post-api/patchApi";
import { MockSetGroup } from "../../../../../component-controller-mod/component-serv/list-fs-cp/media-list-op/ts/setting-list-tier.type";

export const MockSetNotification: MockSetGroup[] = [
    {
        id: 1,
        title: "Notification",
        description: "Choose which notifications you want to receive",
        items: [
            {
                id: 1,
                title: "Inbox",
                description: "Receive notifications for sync events and updates",
                controlType: "toggle"
            },
            {
                id: 2,
                title: "Workflow",
                description: "Receive notifications for workflow updates and changes",
                controlType: "toggle"
            },
            {
                id: 3,
                title: "Job application",
                description: "Receive notifications for new job applications",
                controlType: "toggle"
            },
            {
                id: 4,
                title: "Announcement",
                description: "Receive notifications for company announcements",
                controlType: "toggle"
            }
        ]
    }
]

export type AlertConfigResponse = {
  success: boolean;
  requestId: string;
  data: {
    module: string;
    settings: {
      alert: {
        application?: { enabled?: boolean };
        inbox?: { enabled?: boolean };
        workflow?: { enabled?: boolean };
        announcement?: { enabled?: boolean };
      };
    };
  };
};

export const getAlertConfiguration = () => ApiGet<AlertConfigResponse>("/api/v1/settings/alert-configuration");

export type AlertUpdateBody = {
  alert?: {
    inbox?: { enabled?: boolean };
    workflow?: { enabled?: boolean };
    application?: { enabled?: boolean };
    announcement?: { enabled?: boolean };
  };
};

//  Update endpoint name if your backend uses a different path
export const patchNotificationSettings = (body: AlertUpdateBody) => ApiPatch("/api/v1/settings/alert-configuration/update", body);